export default __webpack_public_path__ + "static/media/Herb.2d792294.png";